export class Endpoint {
    accessor;
    includeAdminPath;
    constructor(accessor, includeAdminPath = true) {
        this.accessor = accessor;
        this.includeAdminPath = includeAdminPath;
    }
}
